<template>
	<div class="vpay__dropdown-option" :class="{ 'vpay__dropdown-option--selected': selected }">
		<span class="vpay__dropdown-option-title">{{ title }}</span>
		<span class="vpay__dropdown-option-subtitle">{{ subtitle }}</span>
	</div>
</template>

<script>
	
	export default {
		
		props: {
			selected: {
				type: Boolean,
				default: false,
			},
			title: {
				default: null,
			},
			subtitle: {
				default: null,
			},
		}
		
	}
	
</script>

<style lang="scss" scoped>
	
	@import "./style.scss";
	
</style>